import React from 'react';
import BikesPage from './bikesPage/BikesPage';
import MapPage from './mapPage/MapPage';
import MenuFilter from './menuFilter/MenuFilter';
import './SampleBike.scss';
import listBikesMock from '../../mock/listBikes';
import { withRouter } from '../../common/withRouter/WithRouter';

class SampleBike extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            bikePage: true,
            mapPage: false,
            brand:'',
            price: this.presetPrice(),
            isLoading: true,
            filters: {
                budget: this.presetPrice() > 0 ? true : false
            },
            bikes: listBikesMock,
            filteredList: listBikesMock
        };

        this.displayRightPage = this.displayRightPage.bind(this);
        this.updateFilters = this.updateFilters.bind(this);
        this.updatePrice = this.updatePrice.bind(this);
    }

    componentDidMount() {
        fetch("https://ubike.be/cms_entities/list", {
            method: 'POST',
            body: JSON.stringify({entity_type: 'BikeModels'})
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState((prevState: any) => {
                        return {
                            ...prevState,
                            isLoading: false,
                            bikes: result,
                            filteredList: result
                        }
                    }, () => this.filterListBike());
                },
                (error) => {
                    this.setState((prevState: any) => {
                        return {
                            ...prevState,
                            isLoading: false,
                            bikes: [],
                            filteredList: []
                        }
                    });
                }
            );
    }

    presetPrice() {
        const url = window.location.href;
        var price = url.substring(url.lastIndexOf('/') + 1);
        return price !== 'sample-bike' ? parseInt(price) : 0;
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if((prevState.filters && prevState.filters !== this.state.filters) 
            || (prevState.filters && prevState.price !== this.state.price)) {
            this.filterListBike();
        }
    }

    updateFilters(label: string, checked: boolean) {
        this.setState((prevState: any) => {
            return {
                ...prevState,
                filters: {
                    ...prevState.filters,
                    [label]: checked
                }
            }
        });
    }

    updatePrice(price: number) {
        this.setState((prevState: any) => {
            return {
                ...prevState,
                price: price ? price : 0
            }
        });
    }

    filterListBike() {
        let filterTab = Object.entries(this.state.filters).filter(filterMenu => filterMenu[1] === true).map((filter: any) => filter[0]);
        
        let filteredListBike = this.state.bikes;
        
        if(filterTab.includes('budget')) {
            filteredListBike = filteredListBike.filter((bike: any) => bike.price <= this.state.price);

        }
        
        if(filterTab.includes('manual') || filterTab.includes('electric')) {
            filteredListBike = filteredListBike.length > 0 ? filteredListBike.filter((bike: any) => filterTab.includes(bike.energy_class)) : filteredListBike;
        }
        
        if(filterTab.includes('city & touring') || filterTab.includes('mountain') || filterTab.includes('road & gravel') || filterTab.includes('cargo') || filterTab.includes('speedelec')) {
            filteredListBike = filterTab.length > 0 ? filteredListBike.filter((bike: any) => filterTab.includes(bike.family)) : filteredListBike;
        }

        this.setState((prevState: any) => {
            return {
                ...prevState,
                filteredList: filterTab.length > 0 ? filteredListBike : this.state.bikes
            }
        });
    }

    displayRightPage(brand = '') {
        this.setState((prevState: any) => {
            return {
                bikePage: prevState.bikePage === true ? false : true,
                mapPage: prevState.mapPage === true ? false : true,
                brand: brand
            }
        })
    }

    render() {
        return (
            <div id="SampleBikeApp" className="SampleBike">
                <MenuFilter updateFilters={this.updateFilters} updatePrice={this.updatePrice} price={this.state.price} priceCheck={this.state.filters.budget} />
                {this.state.bikePage ? <BikesPage displayRightPage={this.displayRightPage} bikeListFiltered={this.state.filteredList} isLoading={this.state.isLoading} /> : <MapPage displayRightPage={this.displayRightPage} brand={this.state.brand} />}
            </div>
        );
    }
}

export default withRouter(SampleBike);